import EcoImgVideo from 'eco-design/base/eco-img-video';
import EcoTab, { EcoTabItemProps } from 'eco-design/elements/eco-tab';
import React, { useState, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import EcoImg from 'eco-design/base/eco-img';
import styles from './index.module.scss';
import { Navigation, Scrollbar } from 'swiper';
import { useLang } from '@/i18n';

const ProductCheckList = () => {
    const { t } = useLang('Delta3MaxSeriesStation.ProductCheckList');
    const contentData: any = {
        a: [
            {
                title: t('item1_title1'),
                img: 'https://websiteoss.ecoflow.com/upload/image/1762322966422/D3M%20(1).png',
            },
            {
                title: t('item1_title2'),
                img: 'https://websiteoss.ecoflow.com/upload/image/1762323410911/%E9%80%9A%E7%94%A8%E7%BA%BF%E6%9D%90.png',
            },
            {
                title: t('item1_title3'),
                img: 'https://websiteoss.ecoflow.com/figma-uploads/1760966410677-hk5ozl-compressed-Frame%201000009141.png',
            },
        ],
        b: [
            {
                title: t('item2_title1'),
                img: 'https://websiteoss.ecoflow.com/upload/image/1762322966608/D3MP.png',
            },
            {
                title: t('item1_title2'),
                img: 'https://websiteoss.ecoflow.com/upload/image/1757558207773/d3mp-wire-1.png',
            },
            {
                title: t('item1_title3'),
                img: 'https://websiteoss.ecoflow.com/figma-uploads/1760966378161-hzw0fv-compressed-Frame%201000009141.png',
            },
        ],
    };

    const [activeItem, setActiveItem] = useState<any>(contentData['a']);
    const items = [
        {
            tabLabel: t('tab_1'),
            tabValue: 'a',
        },
        {
            tabLabel: t('tab_2'),
            tabValue: 'b',
        },
    ];

    const toggleItemHandle = (item: EcoTabItemProps, index: number) => {
        setActiveItem(contentData[item.tabValue]);
    };

    return (
        <section className={`${styles.ProductCheckList} GtmModuleData-section`} data-section-id={'ProductCheckList'}>
            <div className="title">{t('title')}</div>

            <div className="content">
                {activeItem.map((item: any, index: number) => (
                    <div className={`item item-${index}`} key={index}>
                        <p className="item-title">{item.title}</p>
                        <div className="item-img">
                            <EcoImg pc={item.img} alt={item.title} />
                        </div>
                    </div>
                ))}
            </div>
            <div className={`content-tab`}>
                <EcoTab onChange={toggleItemHandle} items={items} theme={'white'} />
            </div>
        </section>
    );
};

export default ProductCheckList;
